




























import { editFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import { LakDruh } from '@/modules/ciselnik/dilenske/lakDruh';

import { types } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	components: {
		LakDruhSelect: LakDruh.components.Select,
	},
	computed: {
		mutationsMappers() {
			return { lakDruh: `${this.storeUri}/${types.mutations.BARVA_LAK_DRUH_SELECT_MAPPER}` };
		},
		lakdruhFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				VyrazenPrp: false,
			};
		},
	},
});
